import { Application } from "stimulus"

const application = Application.start()

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import InputValueController from "./input_value_controller"
application.register("input-value", InputValueController)

import RevealWeekdaysController from "./reveal_weekdays_controller"
application.register("reveal-weekdays", RevealWeekdaysController)

import TodoParserController from "./todo_parser_controller"
application.register("todo-parser", TodoParserController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import AdvanceUrlController from "./advance_url_controller"
application.register("advance-url", AdvanceUrlController)

import Sortable from "stimulus-sortable"
application.register("sortable", Sortable)

import Reveal from "stimulus-reveal-controller"
application.register("reveal", Reveal)

import TodoCheckController from "./todo_check_controller"
application.register("todo-check", TodoCheckController)
